import(/* webpackMode: "eager" */ "/vercel/path0/buyer-fe-next-export/src/app/page.js");
